import React from 'react';
import {SafeAreaView, ScrollView} from 'react-native';
import styles from './BaseScreen.style';

export default function BaseScreen(props) {
  const {children, containerStyle, scrollDisable} = props;

  return (
    <SafeAreaView style={[styles.areaContainer, {flex: 1}, containerStyle]}>
      {/* <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.scrollViewContent}
        showsVerticalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
        scrollEnabled={!scrollDisable}> */}
        {children}
      {/* </ScrollView> */}
    </SafeAreaView>
  );
}
